export default __webpack_public_path__ + "static/logo-5-e5d9beb4ac507186ef4f36b2299080ae.webp";